<template>
    <div class="complie-prompt">
        <!--  start -->
        <div class="complie-prompt-con no-real-name f-clearfix" v-show="userDefaultIdentity" v-if="userIdentityData.tglVerify.code == -2">
            <span class="ico ico-prompt f-fl"></span>
            <p class="complie-prompt-text f-fl f-hide-col-1">
                您的实名认证信息已被驳回（{{userIdentityData.tglVerify.msg}}），请重新认证
            </p>
            <router-link class="g-btn f-fr js-register-btn" :to="{name: 'v4-set-account'}">实名认证</router-link>
        </div>

        <div class="complie-prompt-con no-real-name f-clearfix" v-show="userDefaultIdentity" v-if="userIdentityData.tglVerify.code == -1">
            <span class="ico ico-prompt f-fl"></span>
            <p class="complie-prompt-text f-fl f-hide-col-1">
                您还未完成TGL实名认证，请先完成注册，去实名认证
            </p>
            <router-link class="g-btn f-fr js-register-btn" :to="{name: 'v4-set-account'}">实名认证</router-link>
        </div>
        <div class="complie-prompt-con no-real-name f-clearfix" v-show="userDefaultIdentity" v-if="userIdentityData.tglVerify.code == 0">
            <span class="ico ico-prompt f-fl"></span>
            <p class="complie-prompt-text f-fl f-hide-col-1">
                您的实名认证信息已审核中，请等待
            </p>
        </div>
        <!-- 提示未实名认证 end -->

        <div class="complie-prompt-con no-real-name f-clearfix" v-show="userDefaultIdentity && showPrivate"
            v-if="!userIdentityData.flowUser.code && ![10,20].includes($store.state.realUserInfo.level)">
            <span class="ico ico-prompt f-fl"></span>
            <p class="complie-prompt-text f-fl f-hide-col-1">
                <!-- 您还未获得内测体验官资格，虽然可以一键多渠道分发，但无法获得流量奖励哟 -->
                您尚在新手期，无法获得流量现金奖励，请努力增加发文数量并提高内容质量
            </p>
            <!-- <a class="g-btn f-fr js-real-name-btn" href="/notice/course.shtml">申请体验官</a> -->
        </div>

        <!-- 提示未实名认证 start -->
        <div class="complie-prompt-con no-real-name f-clearfix" v-show="userDefaultIdentity" v-if="!userIdentityData.qqVerify">
            <span class="ico ico-prompt f-fl"></span>
            <p class="complie-prompt-text f-fl f-hide-col-1">你的QQ钱包还未实名，无法收到奖励呦~查看如何QQ钱包实名</p>
            <a class="g-btn f-fr js-real-name-btn" @click="showqqVerify" href="javascript:;">钱包实名</a>
        </div>
        <!-- 提示未实名认证 end -->

        <!-- 提示已实名，但与TGL不一致 start -->
        <div class="complie-prompt-con atypism f-clearfix" v-show="userDefaultIdentity" v-if="userIdentityData.qqVerify == true && userIdentityData.tglAndQqVerify == false">
            <span class="ico ico-prompt f-fl"></span>
            <p class="complie-prompt-text f-fl f-hide-col-1">你的QQ钱包实名信息与TGL注册信息不一致，无法收到奖励呦~查看如何QQ钱包实名</p>
            <a class="g-btn f-fr js-atypism-btn" href="javascript:;" @click="showTglAndQqVerify">钱包实名</a>
        </div>
        <!-- 提示实名认证 end -->

        <div class="complie-prompt-con no-real-name f-clearfix" v-show="userDefaultIdentity && showPrivate"
            v-if="(userIdentityData.tglVerify.code == 1) && userIdentityData.qqVerify && userIdentityData.tglAndQqVerify && userIdentityData.flowUser.code">
            <span class="ico ico-prompt f-fl"></span>
            <p class="complie-prompt-text f-fl f-hide-col-1">
                <!-- 恭喜成为内测体验官，投稿优质原创内容获取QQ钱包现金流量奖励呦 -->
                恭喜成为享受流量奖励的正式作者，投稿优质原创内容，并勾选“参与流量奖励”即可根据文章流量获得现金奖励
            </p>
        </div>
        <real-name-pop ref="realNamePop"></real-name-pop>
    </div>
</template>
<style lang="scss" scoped>
@import "~Assets/sass/pages/v4/common/_config_theme.scss";
// 提示条内容
.complie-prompt {
    padding-bottom: 0;
}
.complie-prompt-con {
    width: 100%;
    height: 50px;
    margin-bottom: 10px;
    background: $color-FFF2E8;
    .ico-prompt {
        margin: 16px 15px 0 30px;
    }
    .complie-prompt-text {
        width: 700px;
        font-size: $middle-font;
        line-height: 50px;
    }
    .g-btn {
        margin-top: 10px;
        margin-right: 30px;
        &:hover {
            background: #ffe4d0;
        }
    }
}
</style>
<script>
import {
    UserUgcIdentity
} from 'Services/getData';
import realNamePop from 'Components/v4/pop/real_name_pop.vue';
export default {
    props: {
        'showPrivate': {
            type: Boolean,
            default: false
        }
    },
    components: {
        realNamePop
    },
    data() {
        return {
            userIdentityData: {
                tglVerify: {
                    code: ''
                },
                flowUser: {}
            },
            userDefaultIdentity: false
        }
    },
    created() {
        this.getUserIdentity();
    },
    methods: {
        showqqVerify() {
            this.$refs.realNamePop.showqqVerify = true;
        },
        showTglAndQqVerify() {
            this.$refs.realNamePop.showTglAndQqVerify = true;
        },
        async getUserIdentity() {
            let res = await UserUgcIdentity();
            this.userDefaultIdentity = true;
            if (res.status === 200 && res.data.code === 0) {
                this.userIdentityData = res.data.data;
                this.$emit('getUserIdentity', this.userIdentityData);
                this.$emit('getResult', this.getResult())
            }
        },
        getResult() {
            let qqStatus = false;
            if (this.userIdentityData.tglVerify.code == -2) {
                return qqStatus;
            }
            else if (this.userIdentityData.tglVerify.code == -1) {
                return qqStatus;
            }
            else if (this.userIdentityData.tglVerify.code == 0) {
                return qqStatus;
            }
            else if (!this.userIdentityData.qqVerify) {
                return qqStatus;
            }
            else if (this.userIdentityData.qqVerify == true && this.userIdentityData.tglAndQqVerify == false) {
                return qqStatus;
            } else {
                qqStatus = true;
            }
            return qqStatus;
        }
    }
}
</script>
